import {
  Button,
  CircularProgress,
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
  Typography,
} from "@material-ui/core";
import TextareaAutosize from "@mui/material/TextareaAutosize";
import { Auth } from "aws-amplify";
import { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
// import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useState } from "react";
import { FaCheckCircle } from "react-icons/fa";
import { TypeAnimation } from "react-type-animation";
import Swal from "sweetalert2";
import { deleteUserFolder } from "../../utils/deleteUserFolder";
import { uploadFileViaPresignedUrl } from "../../utils/uploadFileViaPresignedUrl";

export default function PromptEngineering({ title, link }) {
  const [trainload, setTrainload] = useState(false);
  const [csvFile, setCsvFile] = useState(null);
  const [csvload, setcsvload] = useState(false);
  const [pdfdone, setPdfDone] = useState(false);
  const [csvdone, setCsvDone] = useState(false);
  const [error, setError] = useState("");
  const [answerload, setAnswerload] = useState(false);
  const [deleteError, setdeleteError] = useState("");
  const [accuracy, setAccuracy] = useState(null);
  const [uploadStatus, setUploadStatus] = useState(false);
  const [uploadStatus1, setUploadStatus1] = useState(false);
  // const [question, setQuestion] = useState("");
  const [selectedModel, setSelectedModel] = useState(
    "anthropic.claude-haiku-4-5-20251001-v1:0",
  );
  const [modeltext, setModelText] = useState("Claude Haiku");
  const [userquery, setQuery] = useState("");
  const [engineeredprompt, setEngineeredprompt] = useState("");
  const [matchquery, setMatchquery] = useState("");
  const [trained, setTrained] = useState(false);
  const [output, setOutput] = useState("");
  const [outputEngineered, setOutputEngineered] = useState("");
  const [isPdfUploading, setIsPdfUploading] = useState(false);
  const [isCsvUploading, setIsCsvUploading] = useState(false);
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    setCsvFile(file);
  };

  const timetaken = useRef(0);
  async function signOut() {
    try {
      await Auth.signOut({ global: true });
      window.location.reload();
    } catch (error) {
      // console.log('error signing out: ', error);
    }
  }
  const [genaiaccess, setgenaiaccess] = useState(false);

  useEffect(() => {
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    var userdata = localStorage.getItem(
      `CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.${username}.userData`,
    );
    if (!userdata) return;
    var jsondata = JSON.parse(userdata);
    let emailAttr = jsondata["UserAttributes"].find(
      (attr) => attr["Name"] === "email",
    );
    let email = emailAttr ? emailAttr["Value"] : "";
    email.includes("genai2244") ? setgenaiaccess(true) : setgenaiaccess(false);
  }, []);

  const [file, setFile] = useState(null);
  const [filedata, setFiledata] = useState(null);
  const [convertedData, setConvertedData] = useState(null);
  const [loading, setLoading] = useState("");
  const [loadingengineered, setLoadingengineered] = useState("");

  const getUsername = () =>
    localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );

  const handleUpload = async () => {
    if (!csvFile) return;
    setIsPdfUploading(true);
    setError("");
    try {
      const username = getUsername();
      await deleteUserFolder(username);
      await uploadFileViaPresignedUrl(csvFile, username);
      setIsPdfUploading(false);
      setPdfDone(true);
      setError("File uploaded successfully.");
      setUploadStatus(true);
    } catch (error) {
      console.error("Error uploading file:", error);
      setError(
        "Error while uploading file, please refresh the page and try again.",
      );
      setIsPdfUploading(false);
      setPdfDone(false);
    }
  };

  const handleTrain = async () => {
    //add filename passing parameter in post request and run post request of chatbot
    if (csvFile && file && pdfdone && csvdone) {
      setError("");
      setTrainload(true);
      setdeleteError("");
      console.log("training started");
      var username = localStorage.getItem(
        "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
      );
      var traindata = JSON.stringify({
        docpath: username,
        docname: csvFile.name,
      });
      var promptdata = JSON.stringify({
        docpath: username,
        docname: file.name,
      });
      const trainoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: traindata,
      };

      const promptoption = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: promptdata,
      };

      // Create the fetch requests
      const requesttrain = fetch(
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/documentloader",
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/prompt-engineering-pdf-training",
        trainoption,
      );
      const requestprompt = fetch(
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/csv-training",
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/prompt-engineering-csv-training",
        promptoption,
      );

      Promise.all([requesttrain, requestprompt])
        .then(async ([trainresponse, promptresponse]) => {
          if (!trainresponse.ok || !promptresponse.ok) {
            setError("Training Failed!");
            setTrainload(false);
            throw new Error("One or both requests failed");
          }
          const data1 = await trainresponse.json();
          const data2 = await promptresponse.json();

          // Handle the data from both responses
          // console.log("Response from endpoint 1:", data1);
          // console.log("Response from endpoint 2:", data2);
          if (trainresponse.ok && promptresponse.ok) {
            setError("Training completed.");
            setTrainload(false);
          }
        })
        .catch((error) => {
          // Handle any errors that occurred during the requests
          console.error("Error:", error);
          setError("Training Failed!");
          setTrainload(false);
        });
    } else {
      Swal.fire({
        html: "<p>Please upload a PDF and CSV file</p>",
      });
    }
  };
  const handleFileUpload = (event) => {
    const uploadedFile = event.target.files[0];
    setFile(uploadedFile);
  };

  const processData = async () => {
    if (!file) return;
    setIsCsvUploading(true);
    var username = localStorage.getItem(
      "CognitoIdentityServiceProvider.29j70cln6jt05tfejrnii8d5d.LastAuthUser",
    );
    try {
      await uploadFileViaPresignedUrl(file, username);
      setIsCsvUploading(false);
      setCsvDone(true);
      setError("Prompt file uploaded successfully.");
      setUploadStatus1(true);
    } catch (error) {
      setCsvDone(false);
      setIsCsvUploading(false);
      setError(
        "Error while uploading prompt file, please refresh the page and try again.",
      );
    }
  };

  useEffect(() => {
    setCsvDone(false);
    setPdfDone(false);
  }, []);
  const generateAnswers = async () => {
    const username = getUsername();
    if (userquery.length > 0) {
      setAnswerload(true);
      setMatchquery("");
      setEngineeredprompt("");
      setOutput("");
      setOutputEngineered("");
      // WARNING: For POST requests, body is set to null by browsers.
      var data = JSON.stringify({
        model: selectedModel,
        question: userquery,
        docpath: username,
      });
      // console.log(selectedModel, "Hi Select model is");
      var xhr = new XMLHttpRequest();

      xhr.addEventListener("readystatechange", function () {
        if (this.readyState === 4) {
          // console.log("Raw responsetext", this.responseText);
          console.log("inside response text ////////");
          setMatchquery("");
          setEngineeredprompt("");

          try {
            let response = JSON.parse(this.responseText);
            // console.log("Parsed response:", response);

            let messageArray = response["messsage"];
            // console.log("Message array:", messageArray);

            if (Array.isArray(messageArray) && messageArray.length > 2) {
              let userQuestion = messageArray[0];
              let engineeredPrompt = messageArray[1];
              let userAnswer = messageArray[2];
              let engineeredAnswer = messageArray[3];

              // console.log("User Question:", userQuestion);
              // console.log("Engineered Prompt:", engineeredPrompt);
              // console.log("User Answer:", userAnswer);
              // console.log("Engineered Ansq:", engineeredAnswer);

              let coreAnswer = messageArray[2];
              // console.log("Core Answer:", coreAnswer);

              setMatchquery(userQuestion);
              setEngineeredprompt(engineeredPrompt);

              // manually adding answer via array (response form backend)
              setOutput(userAnswer);
              setOutputEngineered(engineeredAnswer);

              // handleQuestionUserQuery(userQuestion);
              // handleQuestionEngineeredQuery(engineeredPrompt);

              // Disable loading indicator
              setAnswerload(false);
            } else {
              console.log("please provide meaningful question.");
              Swal.fire("please provide meaningful question.");
              setAnswerload(false);
            }
          } catch (error) {
            console.error("Error parsing response or handling data:", error);
            Swal.fire("An error occurred while processing your request.");
            setAnswerload(false);
          }
        }
      });

      xhr.open(
        "POST",
        // "https://ixies944jb.execute-api.ap-south-1.amazonaws.com/dev/prompt-engineering-generate-answer"
        "https://6twdcbjz17.execute-api.ap-south-1.amazonaws.com/dev/prompt-engineering-generate-answer",
      );
      xhr.setRequestHeader("Content-Type", "application/json");

      xhr.send(data);
    } else if (!userquery) {
      Swal.fire("Please asked question.");
    } else {
      Swal.fire("Please upload prompt data and train it.");
    }
  };

  return (
    <div>
      <div>
        <img
          alt="main-background-img"
          id="backgroundmainimageoverlay"
          src="/assets/images/background/g7.mp4"
          style={{
            filter: "opacity(0.2)",
            position: "fixed",
            zIndex: "-3",
            width: "100vw",
            height: "110vh",
            marginTop: "-10vh",
            overflow: "hidden",
          }}
        />
        <img
          alt="main-background"
          style={{ zIndex: "-4" }}
          id="backgroundmainimage"
          src="/assets/images/background/MainBackground.png"
        />
      </div>
      <div className="container-fluid navcontent">
        <div className="row justify-content-between">
          <div className="col-auto align-self-end">
            <div>
              <Grid
                style={{ display: "flex", position: "relative", zIndex: "4" }}
              >
                <Link to={link}>
                  <Button variant="contained" component="span" color="primary">
                    Back
                  </Button>
                </Link>
              </Grid>
            </div>
          </div>
          <div className="col-auto align-self-end basicheader">
            <h2 style={{ paddingTop: "10vh !important", fontWeight: "bold" }}>
              {title}
            </h2>
          </div>
          <div className="col-auto align-self-end">
            <Button
              style={{
                backgroundColor: "#ffa502",
                position: "relative",
                zIndex: "4",
              }}
              variant="contained"
              onClick={() => {
                signOut();
              }}
              color="primary"
              component="span"
            >
              Sign Out
            </Button>
          </div>
        </div>
      </div>

      {genaiaccess ? (
        <div>
          <div
            style={{
              flex: "0.3",
              marginBottom: "1rem",
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-evenly",
              width: "fit-content",
              gap: "3rem",
            }}
            className="input-form-chatbot"
          >
            <div className="section-container">
              <h4>
                <strong>File upload window</strong>
              </h4>
              <hr style={{ background: "white" }}></hr>
              <div>
                <p>Upload a PDF file containing data:</p>
                <div className="field">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      accept=".pdf"
                      id="pdf-upload"
                      type="file"
                      onChange={handleFileChange}
                      style={{ display: "none" }}
                    />
                    <label htmlFor="pdf-upload">
                      <Button
                        variant="contained"
                        component="span"
                        style={{ width: "130px", marginRight: "1rem" }}
                      >
                        Select PDF
                      </Button>
                    </label>

                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      disabled={!csvFile}
                      onClick={handleUpload}
                      startIcon={
                        isPdfUploading && (
                          <CircularProgress color="white" size={20} />
                        )
                      }
                    >
                      Upload PDF
                    </Button>
                    {uploadStatus && (
                      <FaCheckCircle
                        style={{
                          marginLeft: "1rem",
                          color: "green",
                        }}
                        size={25}
                      />
                    )}
                  </div>
                  <Typography variant="body1">
                    <p style={{ wordBreak: "break-all", width: "350px" }}>
                      {csvFile && `Selected file: ${csvFile.name}`}
                    </p>
                  </Typography>
                </div>
                <p>Upload a CSV file containing list of prompts:</p>
                <div className="field">
                  <div style={{ display: "flex", alignItems: "center" }}>
                    <input
                      accept=".csv"
                      id="csv-upload"
                      type="file"
                      style={{ display: "none" }}
                      onChange={handleFileUpload}
                    />
                    <label htmlFor="csv-upload">
                      <Button
                        variant="contained"
                        component="span"
                        style={{ width: "130px", marginRight: "1rem" }}
                      >
                        Select CSV
                      </Button>
                    </label>
                    <Button
                      variant="contained"
                      color="primary"
                      component="span"
                      disabled={!file}
                      onClick={() => {
                        processData(filedata);
                      }}
                      startIcon={
                        isCsvUploading && (
                          <CircularProgress color="white" size={20} />
                        )
                      }
                    >
                      Upload CSV
                    </Button>
                    {uploadStatus1 && (
                      <FaCheckCircle
                        style={{
                          marginLeft: "1rem",
                          color: "green",
                        }}
                        size={25}
                      />
                    )}
                  </div>
                  <Typography variant="body1">
                    <p style={{ wordBreak: "break-all", width: "350px" }}>
                      {file && `Selected file: ${file.name}`}
                    </p>
                  </Typography>
                </div>
              </div>

              <div style={{ display: "flex" }}>
                <Button
                  variant="contained"
                  color="primary"
                  component="span"
                  style={{ color: "white" }}
                  onClick={handleTrain}
                  startIcon={
                    trainload && <CircularProgress color="white" size={20} />
                  }
                >
                  Train
                </Button>
              </div>
              <br />
              {console.log(error)}
              <p>{error}</p>
            </div>
            <div className="section-container">
              <h4>
                <strong>Model selection window</strong>
              </h4>
              <hr style={{ background: "white" }}></hr>
              <FormControl>
                <RadioGroup
                  style={{ width: "18rem" }}
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue="female"
                  name="radio-buttons-group"
                  value={selectedModel}
                  onChange={(e) => {
                    if (e.target.value === "meta.llama3-70b-instruct-v1:0") {
                      setModelText("LLAMA 3");
                    } else if (
                      e.target.value ===
                      "anthropic.claude-haiku-4-5-20251001-v1:0"
                    ) {
                      setModelText("Claude Haiku");
                    } else if (e.target.value === "ai21.j2-ultra-v1") {
                      setModelText("Jurassic-2 Ultra");
                    }
                    setSelectedModel(e.target.value);
                  }}
                >
                  <FormControlLabel
                    value="anthropic.claude-haiku-4-5-20251001-v1:0"
                    control={<Radio />}
                    label="Claude Haiku"
                  />
                  <FormControlLabel
                    value="meta.llama3-70b-instruct-v1:0"
                    control={<Radio />}
                    label="LLAMA 3"
                  />
                  <FormControlLabel
                    value="ai21.j2-ultra-v1"
                    control={<Radio />}
                    label="Jurassic-2 Ultra"
                  />
                </RadioGroup>
              </FormControl>
            </div>
          </div>
          <div className="input-form-chatbot">
            <div className="section-container">
              <p>Enter a question based on the PDF data file:</p>
              {/* <TextField
                id="outlined-basic"
                label="question"
                variant="outlined"
                color="white"
                style={{
                  border: "1px solid white",
                  borderRadius: "0.5rem",
                  width: "100%",
                }}
                value={userquery}
                onChange={(e) => {
                  setQuery(e.target.value);
                }}
              /> */}
              <TextareaAutosize
                id="outlined-basic"
                label="question"
                variant="outlined"
                minRows={1}
                value={userquery}
                onChange={(e) => setQuery(e.target.value)}
                style={{
                  border: "1px solid white",
                  borderRadius: "0.5rem",
                  width: "100%",
                  color: "white",
                  backgroundColor: "transparent",
                  padding: "16.5px 14px", // Adjusted padding to match TextField height
                  fontSize: "16px", // Same font size as TextField
                  lineHeight: "1.4375em", // Match the line height of MUI TextField
                  resize: "none", // Disable manual resizing
                  overflow: "hidden", // Hide scrollbar
                  boxSizing: "border-box", // Ensure padding and border are included in the element's width and height
                }}
              />
              <Button
                style={{ margin: "1rem 0" }}
                variant="contained"
                color="primary"
                onClick={generateAnswers}
                // disabled={!handleTrain}
                startIcon={
                  answerload && <CircularProgress color="white" size={20} />
                }
              >
                Generate Answer
              </Button>
            </div>
          </div>
          <div>
            <div
              className="input-form-chatbot"
              style={{ gap: "1rem", padding: "1rem" }}
            >
              <div className="section-container" style={{ minHeight: "10rem" }}>
                <p>Matched simple prompt from the CSV file:</p>
                {matchquery.length > 0 && (
                  <TypeAnimation
                    key={matchquery}
                    sequence={[matchquery]}
                    cursor={false}
                    speed={70}
                  />
                )}

                <br />
                {accuracy !== null && (
                  <TypeAnimation
                    key={parseFloat(accuracy).toFixed(2) * 100}
                    sequence={[
                      `Accuracy: ${parseFloat(accuracy * 100).toFixed(2)}%`,
                    ]}
                    cursor={false}
                    speed={70}
                  />
                )}
              </div>
              <br />
              <div className="section-container" style={{ minHeight: "10rem" }}>
                <p>Response on the simple prompt:</p>
                {output.length > 0 ? (
                  <TypeAnimation
                    key={output}
                    sequence={[output]}
                    cursor={false}
                    speed={70}
                  />
                ) : (
                  loading.length > 0 && (
                    <TypeAnimation
                      key={loading}
                      sequence={[loading]}
                      cursor={false}
                      speed={25}
                      repeat={10}
                    />
                  )
                )}
              </div>
            </div>
            <div
              className="input-form-chatbot"
              style={{ gap: "1rem", padding: "1rem" }}
            >
              <div className="section-container" style={{ minHeight: "10rem" }}>
                <p>
                  Corresponding engineered prompt of the simple prompt from the
                  CSV file:
                </p>
                {engineeredprompt.length > 0 && (
                  <TypeAnimation
                    key={engineeredprompt}
                    sequence={[engineeredprompt]}
                    cursor={false}
                    speed={70}
                  />
                )}
              </div>
              <br></br>
              <div className="section-container" style={{ minHeight: "10rem" }}>
                <p>Response on the engineered prompt:</p>
                {outputEngineered.length > 0 ? (
                  <TypeAnimation
                    key={outputEngineered}
                    sequence={[outputEngineered]}
                    cursor={false}
                    speed={70}
                  />
                ) : (
                  loadingengineered.length > 0 && (
                    <TypeAnimation
                      key={loadingengineered}
                      sequence={[loadingengineered]}
                      cursor={false}
                      speed={25}
                      repeat={10}
                    />
                  )
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        <h2 style={{ color: "white", textAlign: "center" }}>
          You do not have an access to use this section.
        </h2>
      )}
    </div>
  );
}
